import {computed, ref, watch} from 'vue';
import {type RouteLocationRaw, useRoute, useRouter} from 'vue-router';

import {UserModel} from '@/entities/User';

/** ?auth=1 — открыть окно входа */
export const AUTH_QUERY = 'auth';
/** ?redirect=/path — куда вернуть после входа */
export const REDIRECT_QUERY = 'redirect';

// Только путь внутри приложения: «//host» читается как адрес другого сайта
const toInternalPath = (value: unknown): string | null =>
    typeof value === 'string' && value.startsWith('/') && !value.startsWith('//') ? value : null;

/**
 * Окно входа по запросу из URL: так гард роутера отправляет гостя с закрытой страницы.
 * @param fallback куда вести после входа, если в URL нет redirect
 */
export function useAuthRequest(fallback: RouteLocationRaw) {
    const route = useRoute();
    const router = useRouter();

    const visible = ref<boolean>(route.query[AUTH_QUERY] === '1');

    // Гард может снова прислать на эту же страницу, тогда она не пересоздаётся
    watch(() => route.query[AUTH_QUERY], (value) => {
        if (value === '1') visible.value = true;
    });

    const redirect = computed<RouteLocationRaw>(() => toInternalPath(route.query[REDIRECT_QUERY]) ?? fallback);

    // Закрыли без входа — чистим URL, чтобы обновление страницы не открыло окно снова.
    // После входа не трогаем: ModalAuth уже переходит по redirect, а replace отменил бы этот переход
    watch(visible, (value) => {
        if (value || UserModel.isAuth.value || !(AUTH_QUERY in route.query)) return;
        const {[AUTH_QUERY]: _auth, [REDIRECT_QUERY]: _redirect, ...query} = route.query;
        router.replace({query});
    });

    return {visible, redirect};
}
